import { useEffect, useState } from 'react'
import deductIcon from "../assets/svg/Canceled.svg"
import partiallyPassedIcon from "../assets/svg/State Icons 5.svg"
import passedIcon from "../assets/svg/State Icons 6.svg"

import { Tune } from '@mui/icons-material'
import CheckIcon from "@mui/icons-material/Check"
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CloseIcon from "@mui/icons-material/Close"
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Menu, MenuItem, Paper, Tab, Tabs } from '@mui/material'
import Checkbox from "@mui/material/Checkbox"
import { DataGrid } from '@mui/x-data-grid'
import axios from 'axios'
import { Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import noData from "../assets/svg/Emptyfile1.svg"
import defaultImg from "../assets/svg/defultImage.svg"
import { newHost } from '../pages/Categories/CategoryProfile'
import { newImageUrl } from '../pages/Manufacturers/ManufactureProfile'

const DailyCheckVanProfile = () => {
  const { id: vanId } = useParams()
  const { user } = useSelector((state) => state.auth);
  const token = user?.token
  const [vehicleChecks, setVehicleChecks] = useState([]);
  const [vehicleChecksDetails, setVehicleChecksDetails] = useState(null);
  const [filterDate, setFilterDate] = useState("");
  const [filteredVehicleChecks, setFilteredVehicleChecks] = useState([]);

  const [submitChangeStatus, setSubmitChangeStatus] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const statuses = [{ title: "Passed", icon: passedIcon, id: "1", value: "passed" }, { title: "Partially passed", value: "partial-passed", icon: partiallyPassedIcon, id: "2" }, { title: "Failed", value: "failed", icon: deductIcon, id: "3" }]
  const [tab, setTab] = useState(0);

  useEffect(() => {
    let data = [...vehicleChecks];


    if (submitChangeStatus) {
      const filteredStatus = submitChangeStatus.toLowerCase()
      data = data.filter((item) => item.status?.toLowerCase() == filteredStatus)
      console.log(data.filter((item) => item.status))

    }
    if (filterDate) {
      data = data.filter((item) => {
        const itemDate = new Date(item.checked_at)
          .toISOString()
          .split("T")[0];
        return itemDate == filterDate;
      });
    }



    setFilteredVehicleChecks(data);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  },
    [vehicleChecks, filterDate, submitChangeStatus]);

  // Vehicle Check

  const getVehicleCheck = async () => {
    try {
      const response = await axios.get(`${newHost}portal/get-vehicle-checks/${vanId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setVehicleChecks(response.data.data?.data)
    } catch (error) {
      console.log(error);

    }
  }
  useEffect(() => {
    getVehicleCheck()
  }, [])

  const columns = [
    {
      field: "checked_at", headerName: "Check Date", flex: 0.9, minWidth: 120,
      renderCell: (params) => {
        return (
          <>
            <div className="">{`${new Date(params.row.checked_at).toLocaleDateString()} - ${new Date(params.row.checked_at).toLocaleTimeString()} `}</div>
          </>
        )
      }
    },
    {
      field: "Name",
      headerName: "Driver Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {

        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            <img
              src={params.row.driver?.profile_photo ? `${newImageUrl}${params.row.driver?.profile_photo_path}` : defaultImg}
              alt={`driver-img`}
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
              }}
            />
            <span className="ms-2">{`${params.row.driver?.first_name} ${params.row.driver?.last_name}`}</span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex gap-2 align-items-center justify-content-center">
          <img
            src={
              params.row?.status == "passed" ? passedIcon : params.row?.status == "partial-passed" ? partiallyPassedIcon : deductIcon
            }
            width={20}
          />
          <span>{params.row?.status}</span>
        </div>
      ),
    },
    {
      field: "failed_count",
      headerName: "Issues",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <>
            <div className="">{`${params.row?.failed_count} issues`}</div>
          </>
        )
      }
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {





        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >

            <IconButton
              style={{ width: "30%" }}
              onClick={() => handleReviewDetailsModalShow(params.row)}
              color="default"
              size="small"
              disableRipple
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];


  // Tools Check
  const [toolsChecks, setToolsChecks] = useState([]);
  const [toolsChecksDetails, setToolsChecksDetails] = useState(null);
  const [filteredToolsChecks, setFilteredToolsChecks] = useState([]);
  const getToolsCheck = async () => {
    try {
      const response = await axios.get(`${newHost}portal/get-equipment-checks/${vanId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setToolsChecks(response.data.data?.data)
    } catch (error) {
      console.log(error);

    }
  }
  useEffect(() => {
    getToolsCheck()
  }, [])
  useEffect(() => {
    let data = [...toolsChecks];


    if (submitChangeStatus) {
      const filteredStatus = submitChangeStatus.toLowerCase()
      data = data.filter((item) => item.status?.toLowerCase() == filteredStatus)
      console.log(data.filter((item) => item.status))

    }
    if (filterDate) {
      data = data.filter((item) => {
        const itemDate = new Date(item.created_at[0])
          .toISOString()
          .split("T")[0];
        return itemDate == filterDate;
      });
    }



    setFilteredToolsChecks(data);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  },
    [toolsChecks, filterDate, submitChangeStatus]);



  const checkEquipmentColumns = [
    {
      field: "created_at", headerName: "Check Date", flex: 0.9, minWidth: 120,
      renderCell: (params) => {
        return (
          <>
            <div className="">{`${new Date(params.row.created_at[0]).toLocaleDateString()} - ${new Date(params.row.created_at[0]).toLocaleTimeString()} `}</div>
          </>
        )
      }
    },
    {
      field: "Name",
      headerName: "Engineer Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {

        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            <img
              src={params.row.stuff[0]?.profile_photo ? `${newImageUrl}${params.row.stuff[0]?.profile_photo_path}` : defaultImg}
              alt={`stuff-img`}
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
              }}
            />
            <span className="ms-2">{`${params.row.stuff[0]?.first_name} ${params.row.stuff[0]?.last_name}`}</span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex gap-2 align-items-center justify-content-center">
          <img
            src={
              params.row?.status == "passed" ? passedIcon : params.row?.status == "partial-passed" ? partiallyPassedIcon : deductIcon
            }
            width={20}
          />
          <span>{params.row?.status}</span>
        </div>
      ),
    },
    {
      field: "non_functional",
      headerName: "Issues",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <>
            <div className="">{`${params.row?.non_functional} issues`}</div>
          </>
        )
      }
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {


        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >

            <IconButton
              style={{ width: "30%" }}
              onClick={() => handleReviewEquipmentCheckShow(params.row)}
              color="default"
              size="small"
              disableRipple
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  // Products Check
  const [productsChecks, setProductsChecks] = useState([]);
  const [filteredProductsChecks, setFilteredProductsChecks] = useState([]);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [orderProductItemsReview, setOrderProductItemsReview] = useState(null);
  const getProductsCheck = async () => {
    try {
      const response = await axios.get(`${newHost}portal/product-checks/vehicle/${vanId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      setProductsChecks(response.data.data?.data)
    } catch (error) {
      console.log(error);

    }
  }
  useEffect(() => {
    getProductsCheck()
  }, [])
  useEffect(() => {
    let data = [...productsChecks];


    if (submitChangeStatus) {
      const filteredStatus = submitChangeStatus.toLowerCase()
      data = data.filter((item) => item.status?.toLowerCase() == filteredStatus)

    }
    if (filterDate) {
      data = data.filter((item) => {
        const itemDate = new Date(item.created_at[0])
          .toISOString()
          .split("T")[0];
        return itemDate == filterDate;
      });
    }



    setFilteredProductsChecks(data);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  },
    [productsChecks, filterDate]);
  const CheckProductsColumns = [
    {
      field: "created_at", headerName: "Check Date", flex: 0.9, minWidth: 120,
      renderCell: (params) => {
        return (
          <>
            <div className="">{`${new Date(params.row.created_at[0]).toLocaleDateString()}`}</div>
          </>
        )
      }
    },
    {
      field: "Name",
      headerName: "Engineer Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {

        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            <img
              src={params.row.stuff[0]?.profile_photo ? `${newImageUrl}${params.row.stuff[0]?.profile_photo_path}` : defaultImg}
              alt={`stuff-img`}
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
              }}
            />
            <span className="ms-2">{`${params.row.stuff[0]?.first_name} ${params.row.stuff[0]?.last_name}`}</span>
          </div>
        );
      },
    },

    {
      field: "totalOrdersCount",
      headerName: "Orders Number",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <>
            <div className="">{`${params.row?.totalOrdersCount} orders`}</div>
          </>
        )
      }

    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {






        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >

            <IconButton
              style={{ width: "30%" }}
              onClick={() => handleReviewProductsCheckShow(params.row)}
              color="default"
              size="small"
              disableRipple
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];


  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const tabs = [
    {
      label: "Vehicle Check", content: <>

        <div className="my-4">
          {filteredVehicleChecks.length > 0 ?
            <div className="data-grid-small">

              <Paper sx={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={filteredVehicleChecks}
                  columns={columns}
                  initialState={{ pagination: { paginationModel } }}
                  pageSizeOptions={[5, 10, 20, 50]}
                  checkboxSelection
                  sx={{ overflow: "hidden" }}
                  slotProps={{
                    pagination: {
                      sx: {
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                    },
                  }}
                />
              </Paper>

            </div> :
            <>
              <div className="flex flex-column text-center">

                <img src={noData} alt="no-data" />
                <p style={{ color: "#535353" }} className=''>No available vehicle checks!</p>
              </div>

            </>

          }






        </div>
      </>
    },
    {
      label: "Equipment & Tools Check", content: <>

        <div className="my-4">
          {filteredToolsChecks.length > 0 ?
            <div className="data-grid-small">

              <Paper sx={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={filteredToolsChecks}
                  columns={checkEquipmentColumns}
                  getRowId={(row) => row.shift_id}
                  initialState={{ pagination: { paginationModel } }}
                  pageSizeOptions={[5, 10, 20, 50]}
                  checkboxSelection
                  sx={{ overflow: "hidden" }}
                  slotProps={{
                    pagination: {
                      sx: {
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                    },
                  }}
                />
              </Paper>

            </div>
            : <div className="flex flex-column text-center">

              <img src={noData} alt="no-data" />
              <p style={{ color: "#535353" }} className=''>No available tools checks!</p>
            </div>}



        </div>
      </>
    },
    {
      label: "Products Check", content: <>

        <div className="my-4">
          {filteredProductsChecks.length > 0 ?
            <div className="data-grid-small">

              <Paper sx={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={filteredProductsChecks}
                  columns={CheckProductsColumns}
                  getRowId={(row) => row.shift_id}
                  initialState={{ pagination: { paginationModel } }}
                  pageSizeOptions={[5, 10, 20, 50]}
                  checkboxSelection
                  sx={{ overflow: "hidden" }}
                  slotProps={{
                    pagination: {
                      sx: {
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                    },
                  }}
                />
              </Paper>

            </div>
            : <div className="flex flex-column text-center">

              <img src={noData} alt="no-data" />
              <p style={{ color: "#535353" }} className=''>No available products checks!</p>
            </div>}



        </div>
      </>
    },
  ];
  const [showReviewDetails, setShowReviewDetails] = useState(false)

  const handleReviewDetailsModalShow = (check) => {

    setVehicleChecksDetails(check)
    setShowReviewDetails(true)
  }
  const handleReviewDetailsModalClose = () => {
    setShowReviewDetails(false)
  }
  const [showReviewEquipmentCheck, setShowReviewEquipmentCheck] = useState(false)

  const handleReviewEquipmentCheckShow = (check) => {
    setToolsChecksDetails(check)
    setShowReviewEquipmentCheck(true)
  }
  const handleReviewEquipmentCheckClose = () => {
    setShowReviewEquipmentCheck(false)
  }
  const [showReviewProductsCheck, setShowReviewProductsCheck] = useState(false);
  const [showViewRequestedProductsCheck, setShowViewRequestedProductsCheck] = useState(false);

  const [productsChecksDetails, setProductsChecksDetails] = useState(null);
  const [packedItemsCheck, setPackedItemsChecks] = useState([]);
  const [unPackedItemsCheck, setUnPackedItemsChecks] = useState([]);

  const [filteredPackedItems, setFilteredPackedItems] = useState([]);
  const [filteredUnpackedItems, setFilteredUnpackedItems] = useState([]);

  const [groupedProducts, setGroupedProducts] = useState({});



  const handleReviewProductsCheckShow = (check) => {
    setProductsChecksDetails(check);
    setPackedItemsChecks(check.packed_products || []);
    setUnPackedItemsChecks(check.unpacked_products || []);
    setShowReviewProductsCheck(true);
  };

  const handleReviewProductsCheckClose = () => {
    setShowReviewProductsCheck(false);
  };

  const getProductCategoryData = (order, variationId) => {
    for (const category of order.categories ?? []) {
      for (const subcategory of category.subcategories ?? []) {
        for (const item of subcategory.items ?? []) {
          for (const product of item.products ?? []) {
            if (String(product.variation_id) === String(variationId)) {
              return {
                categoryId: category.id,
                categoryName: category.name,
                categoryIcon: category.icon_url,
                subcategoryId: subcategory.id,
                subcategoryName: subcategory.name,
                subcategoryIcon: subcategory.icon_url,
              };
            }
          }
        }
      }
    }
    return null;
  };

  const groupProductsByService = (allItems) => {
    return allItems.reduce((grouped, item) => {
      const key = item.categoryData?.subcategoryId ?? "unknown";
      if (!grouped[key]) {
        grouped[key] = {
          serviceName: item.categoryData?.subcategoryName ?? "خدمة أخرى",
          serviceIcon: item.categoryData?.subcategoryIcon ?? null,
          categoryIcon: item.categoryData?.categoryIcon ?? null,
          products: [],
        };
      }
      grouped[key].products.push(item);
      return grouped;
    }, {});
  };

  const handleViewRequestedProductsCheckShow = (order) => {
    const mapItem = (item) => ({
      ...item,
      categoryData: getProductCategoryData(order, item.product_variation_id),
    });

    const packed = packedItemsCheck
      .filter((item) => String(item.order_id) === String(order.id))
      .map(mapItem);

    const unpacked = unPackedItemsCheck
      .filter((item) => String(item.order_id) === String(order.id))
      .map(mapItem);

    setGroupedProducts(groupProductsByService([...packed, ...unpacked]));
    setOrderProductItemsReview(order);
    setShowReviewProductsCheck(false);
    setShowViewRequestedProductsCheck(true);
  };

  const handleViewRequestedProductsCheckClose = () => {
    setShowViewRequestedProductsCheck(false);
  };


  const TotalCount = vehicleChecksDetails?.checklist.filter(item => item.is_checked == "passed" || item.is_checked == "failed").length;
  const passedCount = vehicleChecksDetails?.checklist.filter(item => item.is_checked == "passed").length;
  const boxStyle = {
    width: 23,
    height: 23,
    border: "2px solid #D1D5DB",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };


  return (
    <>
      <Modal show={showReviewDetails} onHide={handleReviewDetailsModalClose} dialogClassName='custom-review-modal-size'>
        <Modal.Header closeButton>
          <Modal.Title className='m-0 w-100'>
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <h6 className="label-size main-text-color">Daily Checks Details</h6>
                <h6 className="fw-semibold">{`${new Date(vehicleChecksDetails?.checked_at).toLocaleDateString()} - ${new Date(vehicleChecksDetails?.checked_at).toLocaleTimeString()}`}</h6>


              </div>
              <div className="mx-3">
                <div style={{ backgroundColor: "#ffffff" }} className="d-flex justify-content-center align-items-center gap-1 px-3 rounded-4">
                  <div className='' style={{ width: "20px", height: "", }}>
                    <img
                      src={vehicleChecksDetails?.status == "passed" ? passedIcon : vehicleChecksDetails?.status == "partial-passed" ? partiallyPassedIcon : deductIcon}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: "",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                    className='main-text-color'
                  >
                    {vehicleChecksDetails?.status}
                  </div>
                </div>
              </div>

            </div>

          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "rtl" }}>
          <div className="my-3 px-2">
            <div className="">
              <div style={{ direction: "rtl" }} className="row">
                <div className="col-md-2 col-12">
                  <div className="main-text-color">
                    <p className="">سليم</p>
                  </div>
                </div>
                <div className="col-md-2 col-12">
                  <div className="main-text-color">
                    <p className="">عطل</p>
                  </div>
                </div>

              </div>
              <div style={{ direction: "rtl" }} className="row align-items-center">
                {vehicleChecksDetails?.checklist.map((check) =>
                  <>
                    <div className="col-md-2 col-12">
                      <div className="">

                        <Checkbox
                          readOnly
                          checked={check.is_checked == "passed"}
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon sx={{ color: "#3BBFAD" }} />

                          }
                        />


                      </div>
                    </div>
                    <div className="col-md-2 col-12">
                      <div className="">
                        <Checkbox
                          // value={sub.id}
                          readOnly
                          checked={check.is_checked == "failed"}
                          icon={<CheckBoxOutlineBlankIcon sx={{ color: "#535353" }} />}
                          checkedIcon={<DisabledByDefaultIcon sx={{ color: "#A80101" }} />}
                        />                                    </div>
                    </div>
                    <div className="col-md-8 col-12">
                      <h6 className="m-0">
                        {check.item?.name_ar}
                      </h6>
                    </div>

                    {check.is_checked == "failed" ?
                      <div className="my-3">
                        <div className="rounded-3 bg-light px-2 py-3">
                          <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                          <p className="fw-semibold label-size">{check.notes ? check.notes : "-"}</p>
                          <img className='custom-images-url my-1 rounded-2' src={check.image_path ? `${newImageUrl}/storage/${check.image_path}` : defaultImg} alt="" />
                        </div>
                      </div>


                      : null}
                  </>
                )}


              </div>

            </div>



          </div>


        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#F8F8F8", direction: "rtl" }} className='d-block'>
          <div className="d-flex justify-content-start">
            <div className="p-2 d-flex gap-3 align-items-center ">
              <h6 className="fw-semibold m-0">ملخص الفحص</h6>
              <p className="main-text-color label-size m-0">{`تم فحص ${TotalCount} من ${vehicleChecksDetails?.checklist.length} اجزاء :`}</p>
            </div>
          </div>

          <div className="d-flex gap-1 align-items-center">
            <div className="">

              <Checkbox
                readOnly
                checked
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon sx={{ color: "#3BBFAD" }} />

                }
              />


            </div>
            <h6 className="m-0">{`${passedCount} سليم`}</h6>
          </div>
          <div className="d-flex gap-1 align-items-center">
            <Checkbox
              readOnly
              checked
              icon={<CheckBoxOutlineBlankIcon />}
              checkedIcon={<DisabledByDefaultIcon sx={{ color: "#A80101" }} />}
            />
            <h6 className="m-0">{`${vehicleChecksDetails?.failed_count} به عطل`}</h6>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={showReviewEquipmentCheck} onHide={handleReviewEquipmentCheckClose} dialogClassName='custom-review-modal-size'>
        <Modal.Header closeButton>
          <Modal.Title className='m-0 w-100'>
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <h6 className="label-size main-text-color">Equipment & Tools Check Details</h6>
                <h6 className="fw-semibold">{`${new Date(toolsChecksDetails?.created_at[0]).toLocaleDateString()} - ${new Date(toolsChecksDetails?.created_at[0]).toLocaleTimeString()}`}</h6>


              </div>
              <div className="mx-3">
                <div style={{ backgroundColor: "#ffffff" }} className="d-flex justify-content-center align-items-center gap-1 px-3 rounded-4">
                  <div className='' style={{ width: "20px", height: "", }}>
                    <img
                      src={toolsChecksDetails?.status == "passed" ? passedIcon : toolsChecksDetails?.status == "partial-passed" ? partiallyPassedIcon : deductIcon}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: "",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                    className='main-text-color'
                  >
                    {toolsChecksDetails?.status}
                  </div>
                </div>
              </div>

            </div>

          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "rtl" }}>
          <div className="my-3 px-2">
            <div className="">
              <div style={{ direction: "rtl" }} className="row">
                <div className="col-md-2 col-12">
                  <div className="main-text-color">
                    <p className="">جاهز</p>
                  </div>
                </div>
                <div className="col-md-2 col-12">
                  <div className="main-text-color">
                    <p className="">غير جاهز</p>
                  </div>
                </div>

              </div>
              <div style={{ direction: "rtl" }} className="row align-items-center">
                {toolsChecksDetails?.checks.map((check) =>
                  <>
                    <div className="col-md-2 col-12">
                      <div className="">

                        <Checkbox
                          readOnly
                          checked={check.status == "functional"}
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon sx={{ color: "#3BBFAD" }} />

                          }
                        />


                      </div>
                    </div>
                    <div className="col-md-2 col-12">
                      <div className="">
                        <Checkbox
                          // value={sub.id}
                          readOnly
                          checked={check.status == "not_functional"}
                          icon={<CheckBoxOutlineBlankIcon sx={{ color: "#535353" }} />}
                          checkedIcon={<DisabledByDefaultIcon sx={{ color: "#A80101" }} />}
                        />                                    </div>
                    </div>
                    <div className="col-md-8 col-12">
                      <h6 className="m-0">
                        {check.equipment?.internal_serial_number}
                      </h6>
                    </div>

                    {check.status == "not_functional" ?
                      <div className="my-3">
                        <div className="rounded-3 bg-light px-2 py-3">
                          <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                          <p className="fw-semibold label-size">{check.notes ? check.notes : "-"}</p>
                          <img className='custom-images-url my-1 rounded-2' src={check.image_url ? `${newImageUrl}${check.image_url}` : defaultImg} alt="" />
                        </div>
                      </div>


                      : null}
                  </>
                )}


              </div>





            </div>



          </div>


        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#F8F8F8", direction: "rtl" }} className='d-block'>
          <div className="d-flex justify-content-start">
            <div className="p-2 d-flex gap-3 align-items-center ">
              <h6 className="fw-semibold m-0">ملخص الفحص</h6>
              <p className="main-text-color label-size m-0">{`تم فحص ${toolsChecksDetails?.total_checked} من ${toolsChecksDetails?.checks.length} أداة على السيارة`}</p>
            </div>
          </div>

          <div className="d-flex gap-1 align-items-center">
            <div className="">

              <Checkbox
                readOnly
                checked
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon sx={{ color: "#3BBFAD" }} />

                }
              />


            </div>
            <h6 className="m-0">{`${toolsChecksDetails?.functional} جاهز`}</h6>
          </div>
          <div className="d-flex gap-1 align-items-center">
            <Checkbox
              readOnly
              checked
              icon={<CheckBoxOutlineBlankIcon />}
              checkedIcon={<DisabledByDefaultIcon sx={{ color: "#A80101" }} />}
            />
            <h6 className="m-0">{`${toolsChecksDetails?.non_functional} غير جاهز`}</h6>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={showReviewProductsCheck} onHide={handleReviewProductsCheckClose} dialogClassName='custom-review-modal-size'>
        <Modal.Header closeButton>
          <Modal.Title className='m-0 w-100'>
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <h6 className="label-size main-text-color">Products Check Details</h6>
                <h6 className="fw-semibold">{`${new Date(productsChecksDetails?.created_at[0]).toLocaleDateString()} - ${new Date(productsChecksDetails?.created_at[0]).toLocaleTimeString()}`}</h6>


              </div>

            </div>

          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "rtl" }}>
          <div className="my-3 px-2">

            <div className="">
              {productsChecksDetails?.totalOrders.map((order) => {
                return (
                  <Accordion
                    key={order.id}
                    expanded={expandedOrder === order.id}
                    onChange={() =>
                      setExpandedOrder(expandedOrder === order.id ? null : order.id)
                    }
                    sx={{
                      backgroundColor: "#F9F9F9",
                      my: 2,
                      py: 1,
                      border: "none",
                      outline: "none",
                      "&:before": {
                        display: "none",
                      },
                      "&.Mui-expanded": {
                        boxShadow: "none",
                      },
                    }}
                    className="shadow-sm"
                  >
                    {/* ===== HEADER ===== */}
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className="row w-100 align-items-center">
                        <div className="col-12 d-flex align-items-center">
                          <img
                            className="services-images-url mx-2"
                            src={order.order_status?.image_url ? order.order_status?.image_url : defaultImg}
                            alt=""
                          />

                          <span className="fw-bold">{`ORD-#${order.id}`}</span>
                          <span className="mx-2">Order</span>
                        </div>
                      </div>
                    </AccordionSummary>

                    {/* ===== DETAILS ===== */}
                    <AccordionDetails>
                      <div className="border rounded-4 p-4">
                        <ul style={{ listStyle: "square inside" }}>
                          <li>
                            {`اسم العميل: ${order.user?.last_activity ? order?.user?.name : "....."
                              }`}
                          </li>

                          {/* ===== SERVICES LIST ===== */}
                          <li>
                            الخدمات المطلوبة:
                            {order.categories?.map((item) =>
                              item?.subcategories?.map((sub) => (
                                <div
                                  key={sub.id}
                                  className="d-flex align-items-center gap-2 m-0"
                                >
                                  <img
                                    className="services-images-url"
                                    src={
                                      item.icon_url
                                        ? `${newImageUrl}${item.icon_url}`
                                        : defaultImg
                                    }
                                    alt=""
                                  />
                                  <p className="m-0">{sub.name}</p>
                                </div>
                              ))
                            )}
                          </li>

                          <li>
                            السعر الكلي:
                            <span className="fw-bold mx-2">
                              {Number(order.total).toLocaleString("en-US")} ج.م
                            </span>
                          </li>

                          <li>{`العنوان: ${order?.address?.area}`}</li>

                          <li>{`الوقت المتوقع: ${order?.scheduled_from} - ${order?.scheduled_to}`}</li>

                          <li>
                            حالة الطلب: {order?.order_status?.label_ar}
                            <img
                              className="services-images-url mx-2"
                              src={order?.order_status?.image_url ? order.order_status?.image_url : defaultImg}
                              alt=""
                            />
                          </li>
                        </ul>

                        {/* ===== BUTTON ===== */}

                        <div className="d-flex justify-content-center mt-3">
                          <button
                            onClick={() => handleViewRequestedProductsCheckShow(order)}
                            className="btn btn-dark px-5"
                          >
                            عرض المواد المطلوبه
                          </button>
                        </div>


                      </div>
                    </AccordionDetails>
                  </Accordion>
                )
              })}


            </div>



          </div>


        </Modal.Body>

      </Modal>


      <Modal show={showViewRequestedProductsCheck} onHide={handleViewRequestedProductsCheckClose} dialogClassName="custom-review-modal-size">
        <Modal.Header closeButton>
          <Modal.Title className="m-0 w-100">
            <div>
              <h6 className="label-size main-text-color">
                Products Check Details
              </h6>
              <h6 className="fw-semibold">
                {`#ORD-${orderProductItemsReview?.id}`}
              </h6>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "rtl" }}>
          <div className="my-3 px-2">
            {Object.values(groupedProducts).map((group, index) => (
              <div key={index} className="my-3">
                <div className="d-flex align-items-center gap-2 my-1">
                  <div className="rounded-2 services-images-url d-flex justify-content-center align-items-center" >
                    <img src={group.categoryIcon ? `${newImageUrl}${group.categoryIcon}` : defaultImg} alt="" />
                  </div>
                  <h6 className="fw-bold m-0">
                    {group.serviceName}
                  </h6>
                </div>
                {group.products.map((product) => (
                  <div key={product.id} className="" >
                    <div className="d-flex align-items-center gap-1">
                      {product.status === "packed" ? <Checkbox checked={product.status === "packed"}
                        checkedIcon={
                          <div style={{ ...boxStyle, backgroundColor: "#3FBEAC" }}>
                            <CheckIcon style={{ color: "#fff", fontSize: 18 }} />
                          </div>
                        }
                        disableRipple /> :
                        <Checkbox checked={product.status === "unpacked"}
                          checkedIcon={
                            <div style={{ ...boxStyle, backgroundColor: "#A80101" }}>
                              <CloseIcon style={{ color: "#fff", fontSize: 18 }} />
                            </div>
                          }
                          disableRipple />}


                      <h6 className="my-2 fw-semibold">
                        {product.variation?.name}
                        <small className="text-muted d-block">
                          SKU: {product.variation?.sku}
                        </small>
                        <small className="text-muted d-block">
                          الكمية: {product.quantity}
                        </small>
                      </h6>

                    </div>

                  </div>))}
              </div>))}
            {Object.keys(groupedProducts).length === 0 && (<div className="text-center py-5">
              <p>لا يوجد منتجات مرتبطة بهذا الطلب</p>
            </div>)}
          </div>
        </Modal.Body>
      </Modal>
      <div className="col-md-12 min-vh-100">
        <div
          className=" p-3 my-3 col-md-12 rounded-2 "
          style={{ border: "2px solid #EAEAEA " }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="">
              <h6 className='m-0'>Daily Checks</h6>
            </div>
            <div className="d-flex gap-2 align-items-center w-50">
              <div className="position-relative w-100">
                <input
                  type="date"
                  className="date-input form-control w-100"
                  value={filterDate}
                  onChange={(e) => {
                    setFilterDate(e.target.value);
                  }}
                />

                {filterDate && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light position-absolute"
                    style={{
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      padding: "2px 6px",
                      fontSize: "12px",
                    }}
                    onClick={() => {
                      setFilterDate("");
                    }}
                  >
                    ✕
                  </button>
                )
                }
              </div>
              <div className=''>
                <div className="btn btn-light">
                  <Tune
                    style={{ cursor: "pointer" }}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                  />
                </div>

                <Menu
                  className='my-2'
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  PaperProps={{
                    sx: {
                      p: 1,
                      minWidth: 150,
                      backgroundColor: "#F9F9F9",
                      borderRadius: "10px"

                    }
                  }}
                >
                  {statuses.map((item) => (
                    <div className="">
                      <MenuItem
                        key={item.value}
                        onClick={() => {
                          console.log(item.value);

                          setSubmitChangeStatus(item.value);
                        }}

                      >
                        <div className="p-2 d-flex gap-3 align-items-center">
                          <img src={item.icon} alt="" />
                          <div className="label-size m-0">{item.title}</div>
                        </div>
                      </MenuItem>
                    </div>
                  ))}
                </Menu>



              </div>
            </div>
          </div>
          <Box className='custom-tab-style' sx={{ marginBlock: 2, borderColor: 'divider' }}>
            <Tabs
              value={tab}

              onChange={(e, v) => setTab(v)}
              sx={{ borderBottom: " 1px solid #D8D8D8", }}
              TabIndicatorProps={{
                sx: {
                  backgroundColor: "#3FBEAC",
                  height: "3px",



                },
              }}

            >
              {tabs.map((t, i) => (
                <Tab
                  key={i}
                  label={t.label}
                  sx={{
                    textTransform: "capitalize",
                  }}

                />
              ))}
            </Tabs>




            <Box>
              {tabs[tab].content}
            </Box>
          </Box>
        </div>
      </div>
    </>
  )
}

export default DailyCheckVanProfile